import { Home, MessageCircle } from "lucide-react";
import { residentialServices } from "@/data/residential";
import { business } from "@/config/business";
import { getWhatsAppUrl } from "@/lib/whatsapp";
import { trackEvent, EVENTS } from "@/lib/tracking";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

export const ResidentialSection = () => {
  return (
    <section
      id="residential"
      data-testid="residential-section"
      className="bg-[#F8FAFC] py-20 sm:py-24 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="03"
          kicker="Untuk Rumah & Hunian"
          title="Layanan AC untuk Rumah Anda"
          description="Perawatan AC dari service rutin hingga maintenance berkala — cepat, mudah, dan langsung dijadwalkan."
        />

        <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {residentialServices.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.id} delay={(i % 3) * 0.07}>
                <article
                  data-testid={`residential-card-${s.id}`}
                  className="group h-full rounded-2xl border border-slate-200 bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-16px_rgba(15,23,42,0.15)]"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#0F172A] text-white transition-colors duration-300 group-hover:bg-[#25D366]">
                    <Icon className="h-5 w-5" />
                  </span>
                  <h3 className="mt-5 text-base font-bold text-slate-900">{s.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.description}</p>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-col items-start gap-4 rounded-2xl bg-[#0F172A] p-7 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-4">
              <span className="flex h-12 w-12 flex-none items-center justify-center rounded-xl bg-[#E0A400]/15 text-[#E0A400]">
                <Home className="h-6 w-6" />
              </span>
              <div>
                <h3 className="text-lg font-bold text-white">Butuh service AC di rumah?</h3>
                <p className="mt-1 text-sm text-slate-300">Jadwalkan langsung via WhatsApp, cepat dan mudah.</p>
              </div>
            </div>
            <a
              href={getWhatsAppUrl(business.whatsappMessages.b2c)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                trackEvent(EVENTS.BOOKING_SERVICE, { source: "residential" });
                trackEvent(EVENTS.WHATSAPP_CLICK, { source: "residential" });
              }}
              data-testid="residential-cta"
              className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-[#25D366] px-6 py-3.5 text-[15px] font-bold text-white transition-colors hover:bg-[#1eb85a] sm:w-auto"
            >
              <MessageCircle className="h-5 w-5" />
              {business.cta.residential}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ResidentialSection;
